import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Message from "../components/Message";
import Loading from "../components/Loading";
import FormContainer from "../components/FormContainer";
import { createProduct } from "../redux/actions/productActions";
import axios from "axios";
import { PRODUCT_CREATE_RESET } from "../redux/constants/productConstants";


const CreateProductScreen = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: PRODUCT_CREATE_RESET });
  }, [dispatch]);


  let navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState(0);
  const [image, setImage] = useState("");
  const [uploading, setUploading] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);
  const [uploadingCarousel, setUploadingCarousel] = useState(false);


  // Sizes array: each item { size, quantity }
  const [sizes, setSizes] = useState([{ size: "", quantity: 0 }]);

  const { loading, success, error } = useSelector(state => state.productCreate);

  useEffect(() => {
    if (success) {
      navigate("/admin/products");
      dispatch({ type: PRODUCT_CREATE_RESET });
    }
  }, [dispatch, success, navigate]);

  const handleSizeChange = (index, field, value) => {
    const updatedSizes = [...sizes];
    updatedSizes[index][field] = field === "quantity" ? Number(value) : value;
    setSizes(updatedSizes);
  };

  const addSizeRow = () => setSizes([...sizes, { size: "", quantity: 0 }]);
  const removeSizeRow = index => setSizes(sizes.filter((_, i) => i !== index));

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      createProduct({
        name,
        description,
        category,
        price,
        image,
        carouselImages,
        sizes, // pass sizes array to backend
      })
    );
  };

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);

    setUploading(true);

    try {
      const config = { headers: { "Content-Type": "multipart/form-data" } };

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/upload`,
        formData,
        config
      );

      setImage(data.imageUrl);
      setUploading(false);
    } catch (error) {
      console.error(error.message);
      setUploading(false);
    }
  };

  const uploadMultipleFilesHandler = async (e) => {
    const files = Array.from(e.target.files);
    setUploadingCarousel(true);

    try {
      const uploadedUrls = [];

      for (const file of files) {
        const formData = new FormData();
        formData.append("image", file);

        const config = { headers: { "Content-Type": "multipart/form-data" } };

        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/upload`,
          formData,
          config
        );

        uploadedUrls.push(data.imageUrl);
      }

      setCarouselImages(uploadedUrls);
      setUploadingCarousel(false);
    } catch (error) {
      console.error(error.message);
      setUploadingCarousel(false);
    }
  };



  return (
    <FormContainer>
      <h2>Create Product</h2>
      <Form onSubmit={handleSubmit}>
        {error && <Message variant="danger">{error}</Message>}
        <Form.Group controlId="name" className="mt-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Name"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="description" className="mt-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            type="text"
            placeholder="Description"
            value={description}
            onChange={e => setDescription(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="category" className="mt-3">
          <Form.Label>Category</Form.Label>
          <Form.Control
            type="text"
            placeholder="Category"
            value={category}
            onChange={e => setCategory(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="price" className="mt-3">
          <Form.Label>Price</Form.Label>
          <Form.Control
            type="number"
            placeholder="Price"
            value={price}
            onChange={e => setPrice(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="image" className="mt-3">
          <Form.Label>Image</Form.Label>
          <Form.Control
            type="file"
            label="Choose file"
            onChange={uploadFileHandler}
          />
          {uploading && <Loading />}
        </Form.Group>

        <Form.Group controlId="carouselImages" className="mt-3">
          <Form.Label>Carousel Images (3 to 5 images)</Form.Label>
          <Form.Control
            type="file"
            label="Choose files"
            multiple
            onChange={uploadMultipleFilesHandler}
          />
          {uploadingCarousel && <Loading />}
        </Form.Group>


        <Form.Group className="mt-3">
          <Form.Label>Sizes & Quantities</Form.Label>
          {sizes.map((item, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <Form.Control
                type="text"
                placeholder="Size (e.g. S, M, L)"
                value={item.size}
                onChange={e => handleSizeChange(index, "size", e.target.value)}
                style={{ width: "100px", marginRight: "10px" }}
                required
              />
              <Form.Control
                type="number"
                placeholder="Quantity"
                value={item.quantity}
                onChange={e => handleSizeChange(index, "quantity", e.target.value)}
                style={{ width: "100px", marginRight: "10px" }}
                min="0"
                required
              />
              <Button variant="danger" onClick={() => removeSizeRow(index)}>X</Button>
            </div>
          ))}
          <Button variant="primary" onClick={addSizeRow}>Add Size</Button>
        </Form.Group>

        <Button className="mt-3" type="submit" variant="primary">
          {loading ? <Loading /> : "Add"}
        </Button>
      </Form>
    </FormContainer>
  );
};

export default CreateProductScreen;
